import SelectBox, { Item, SelectBoxProps } from '@/components/select/SelectBox';
import { Status } from '@/models/Status';

type ProductListStatusSelectBoxProps<T extends Item> = SelectBoxProps<T>;

interface ProductListStatusItem {
  id: Status;
  name: string;
}

const productListStatuses: ProductListStatusItem[] = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' },
];

const ProductListStatusSelectBox = (
  props: ProductListStatusSelectBoxProps<ProductListStatusItem>,
) => {
  const { label = 'Status:', placeholder = 'Select status' } = props;

  const listProductListStatuses = (): Promise<ProductListStatusItem[]> =>
    Promise.resolve(productListStatuses);

  return (
    <SelectBox<ProductListStatusItem>
      {...props}
      name="productListStatus"
      label={label}
      placeholder={placeholder}
      deselectLabel="All statuses"
      queryFn={listProductListStatuses}
    />
  );
};

export default ProductListStatusSelectBox;
